import { render, staticRenderFns } from "./Statistiques.vue?vue&type=template&id=162bf6a8&scoped=true&"
import script from "./Statistiques.vue?vue&type=script&lang=js&"
export * from "./Statistiques.vue?vue&type=script&lang=js&"
import style0 from "./Statistiques.vue?vue&type=style&index=0&id=162bf6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162bf6a8",
  null
  
)

export default component.exports